import { BlocksIconShop } from 'blocks-nextjs/blocks-web-components/components/icon/icons/shop';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconShop = createComponent({ react: React, tagName: 'cat-icon-shop', elementClass: BlocksIconShop });
